import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-svg-cms',
    templateUrl: './svg-cms.component.html',
    styleUrls: ['./svg-cms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SvgCmsComponent implements OnInit {

  @Input() iconSrc: string = '';
  @Input() iconSize: number = 90;
  public iconSizeInPx: string = '';

  constructor() { }

  ngOnInit(): void {
    this.iconSizeInPx = this.iconSize + 'px';
  }

}
